module.exports = __webpack_public_path__ + "static/media/time2.1d6d7509.svg";